<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="lg:col-6 col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.client">
              Клиент
            </label>
            <crm-single-select
              [isError]="$any(errors?.client)"
              [options]="clients"
              [(selectedItem)]="task.client"
              (selectedItemChange)="selectedClient($event)"
              [showClear]="true"
              appendTo="body">
            </crm-single-select>
            <small
              *ngIf="errors?.client"
              class="p-error">
              {{ errors.client | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Описание</label>
            <crm-editor
              [(value)]="task.description"
              height="250px"></crm-editor>
            <small
              *ngIf="errors?.description"
              class="p-error">
              {{ errors.description | join }}
            </small>
          </div>

          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.deadline">
              Дедлайн
            </label>
            <crm-datepicker
              [(value)]="task.deadline"
              [showTime]="true"
              [stepMinute]="15"
              [inputStyleClass]="errors?.deadline ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-datepicker>
            <small
              *ngIf="errors?.deadline"
              class="p-error">
              {{ errors.deadline | join }}
            </small>
          </div>

          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.taskType">
              Тип заявки
            </label>
            <crm-hd-task-type-single-select
              [customRequest]="true"
              [taskTypes]="taskTypes"
              [(selectedTaskType)]="task.taskType"
              [showClear]="true"
              [styleClass]="errors?.taskType ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.taskType ? 'ng-invalid ng-dirty' : ''"
              (selectedTaskTypeChange)="
                setDefaultPriorityAndDeadline(task.taskType);
                setDefaultResponsibleAndUserGroups(task.taskType);
                setEntityType(task.taskType)
              "
              appendTo="body">
            </crm-hd-task-type-single-select>
            <small
              *ngIf="errors?.taskType"
              class="p-error">
              {{ errors.taskType | join }}
            </small>
          </div>

          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.unit">
              Бизнес единица
            </label>
            <crm-unit-single-select
              [(selectedUnit)]="task.unit"
              [isError]="$any(errors?.unit)"
              [showClear]="true"
              appendTo="body"></crm-unit-single-select>
            <small
              *ngIf="errors?.unit"
              class="p-error">
              {{ errors.unit | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Эпик</label>
            <crm-master-milestone-single-select
              [(selectedMasterMilestone)]="task.masterMilestone"
              [isError]="$any(errors?.masterMilestone)"
              appendTo="body"></crm-master-milestone-single-select>
            <small
              *ngIf="errors?.masterMilestone"
              class="p-error">
              {{ errors.masterMilestone | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Приоритет</label>
            <crm-single-select
              dataKey="name"
              [options]="priorities"
              [(selectedItem)]="task.priority"
              [styleClass]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
              [isTemplateCombined]="true"
              [filter]="false"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-priority="item">
                {{ priority?.value | helpdeskTaskPriorityName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.priority"
              class="p-error">
              {{ errors.priority | join }}
            </small>
          </div>

          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.plannedMin">
              Время план
            </label>
            <p-inputNumber
              [(ngModel)]="task.plannedMin"
              [ngClass]="{ 'ng-invalid ng-dirty': errors?.plannedMin }"></p-inputNumber>
            <small
              *ngIf="errors?.plannedMin"
              class="p-error">
              {{ errors.plannedMin | join }}
            </small>
          </div>
        </div>
      </p-card>

      <div
        *ngIf="task.taskType?.entityType?.attributes?.length"
        class="mt-3">
        <p-card header="Дополнительные реквизиты">
          <div class="p-fluid">
            <ng-container *ngFor="let attribute of task.taskType.entityType.attributes | orderBy: 'id:number'">
              <ng-container [ngSwitch]="attribute.type">
                <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.FILIAL">
                  <div class="field">
                    <label
                      class="font-medium"
                      [class.required-field]="isRequiredField(attribute)">
                      {{ attribute.name }}
                    </label>
                    <ng-container *ngIf="attribute.multipleSelect; else singleSelect">
                      <crm-filial-multi-select
                        [(selectedFilials)]="task.eavEntity.values[attribute.id]"
                        [isFloatLabel]="false"
                        [showClear]="true"
                        appendTo="body"></crm-filial-multi-select>
                    </ng-container>
                    <ng-template #singleSelect>
                      <crm-filial-single-select
                        [(selectedFilial)]="task.eavEntity.values[attribute.id]"
                        [showClear]="true"
                        appendTo="body"></crm-filial-single-select>
                    </ng-template>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.COST_CENTER">
                  <div class="field">
                    <label
                      class="font-medium"
                      [class.required-field]="isRequiredField(attribute)">
                      {{ attribute.name }}
                    </label>
                    <ng-container *ngIf="attribute.multipleSelect; else singleSelect">
                      <crm-cost-center-multi-select
                        [(selectedCostCenters)]="task.eavEntity.values[attribute.id]"
                        [showClear]="true"
                        appendTo="body"></crm-cost-center-multi-select>
                    </ng-container>
                    <ng-template #singleSelect>
                      <crm-cost-center-single-select
                        [(selectedCostCenter)]="task.eavEntity.values[attribute.id]"
                        [showClear]="true"
                        appendTo="body"></crm-cost-center-single-select>
                    </ng-template>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.TEXT">
                  <div class="field">
                    <label
                      class="font-medium"
                      [class.required-field]="isRequiredField(attribute)">
                      {{ attribute.name }}
                    </label>
                    <crm-input-text
                      [(value)]="task.eavEntity.values[attribute.id]"
                      class="w-full"></crm-input-text>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.NUMBER">
                  <div class="field">
                    <label
                      class="font-medium"
                      [class.required-field]="isRequiredField(attribute)">
                      {{ attribute.name }}
                    </label>
                    <p-inputNumber [(ngModel)]="task.eavEntity.values[attribute.id]"></p-inputNumber>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.DATE">
                  <div class="field">
                    <label
                      class="font-medium"
                      [class.required-field]="isRequiredField(attribute)">
                      {{ attribute.name }}
                    </label>
                    <crm-datepicker
                      [(value)]="task.eavEntity.values[attribute.id]"
                      appendTo="body"></crm-datepicker>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.TIMESTAMP">
                  <div class="field">
                    <label
                      class="font-medium"
                      [class.required-field]="isRequiredField(attribute)">
                      {{ attribute.name }}
                    </label>
                    <crm-datepicker
                      [(value)]="task.eavEntity.values[attribute.id]"
                      [showTime]="true"
                      [stepMinute]="15"
                      appendTo="body"></crm-datepicker>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.DATE_PERIOD">
                  <div class="field">
                    <label
                      class="font-medium"
                      [class.required-field]="isRequiredField(attribute)">
                      {{ attribute.name }}
                    </label>
                    <crm-daterangepicker
                      [value]="[period.from, period.to]"
                      (changeValue)="setDates($event, attribute)"
                      appendTo="body"></crm-daterangepicker>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.FILES">
                  <div class="field">
                    <div
                      *ngIf="task.eavEntity.values[attribute.id]?.length"
                      class="mb-2">
                      <crm-files-list
                        [files]="task.eavEntity.values[attribute.id]"
                        [canDelete]="true"
                        (deleteFile)="deleteFile(task.eavEntity.values[attribute.id], $event)"></crm-files-list>
                    </div>
                    <p-fileUpload
                      #fileUpload
                      mode="basic"
                      [customUpload]="true"
                      chooseIcon="pi-paperclip"
                      [chooseLabel]="attribute.name"
                      [disabled]="filesLoading"
                      (uploadHandler)="uploadFiles($event, attribute)"
                      [auto]="true">
                    </p-fileUpload>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.BOOLEAN">
                  <div class="field-checkbox">
                    <p-checkbox
                      [(ngModel)]="task.eavEntity.values[attribute.id]"
                      [binary]="true"
                      [inputId]="attribute.id.toString()"></p-checkbox>
                    <label [for]="attribute.id.toString()">{{ attribute.name }}</label>
                  </div>
                </ng-container>
              </ng-container>
              <small
                *ngIf="errors?.eavEntity?.values?.[attribute.id]"
                class="p-error">
                {{ errors.eavEntity.values[attribute.id] | join }}
              </small>
            </ng-container>
          </div>
        </p-card>
      </div>
    </div>

    <div class="lg:col-6 col-12 flex gap-3 flex-column">
      <p-card header="Участники">
        <div class="p-fluid">
          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.responsible">
              Ответственный
            </label>
            <crm-user-single-select
              [users]="users"
              [(selectedUser)]="task.responsible"
              [customSearch]="true"
              [isError]="$any(errors?.responsible)"
              appendTo="body"></crm-user-single-select>
            <small
              *ngIf="errors?.responsible"
              class="p-error">
              {{ errors.responsible | join }}
            </small>
          </div>

          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.externalUser">
              Внешний пользователь
            </label>
            <div class="flex align-items-center gap-1">
              <div class="flex-grow-1">
                <crm-external-user-single-select
                  [customSearch]="true"
                  [externalUsers]="externalUsers"
                  [(selectedExternalUser)]="task.externalUser"
                  [isError]="$any(errors?.externalUser)"
                  [disabled]="!task.client?.contragents?.length"
                  appendTo="body"></crm-external-user-single-select>
              </div>
              <p-button
                *ngIf="task.client?.id && task.client?.contragents?.length"
                icon="pi pi-plus"
                (click)="openFormCreateExternalUser()"></p-button>
            </div>
            <small
              *ngIf="errors?.externalUser"
              class="p-error">
              {{ errors.externalUser | join }}
            </small>
          </div>

          <h3 class="font-medium -mb-2">Аудиторы</h3>
          <p-divider></p-divider>
          <div class="formgrid grid">
            <div class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="requiredFields?.userAuditors">
                Пользователи
              </label>
              <crm-user-multi-select
                [users]="users"
                [(selectedUsers)]="task.userAuditors"
                [customRequest]="true"
                [isFloatLabel]="false"
                appendTo="body"></crm-user-multi-select>
            </div>

            <div class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="requiredFields?.userGroupAuditors">
                Группы
              </label>
              <crm-multi-select
                [(selectedItems)]="task.userGroupAuditors"
                [options]="userGroups"
                appendTo="body">
              </crm-multi-select>
            </div>

            <div class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="requiredFields?.externalUserAuditors">
                Внешние пользователи
              </label>
              <crm-external-user-multi-select
                [(selectedExternalUsers)]="task.externalUserAuditors"
                [clientId]="task.client?.id"
                appendTo="body"></crm-external-user-multi-select>
            </div>
          </div>
        </div>
      </p-card>

      <p-card header="Сделка">
        <div class="p-fluid">
          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.deal">
              Сделка
            </label>
            <crm-deal-auto-complete
              [(selectedDeal)]="task.deal"
              [isError]="$any(errors?.deal)"
              [showClear]="true"
              appendTo="body"></crm-deal-auto-complete>
            <small
              *ngIf="errors?.deal"
              class="p-error">
              {{ errors.deal | join }}
            </small>
          </div>
        </div>
      </p-card>

      <p-card header="Задача">
        <div class="p-fluid">
          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="requiredFields?.project">
              Задача
            </label>
            <crm-project-auto-complete
              [(selectedProject)]="task.project"
              [showClear]="true"
              [isError]="$any(errors?.project)"
              appendTo="body"></crm-project-auto-complete>
            <small
              *ngIf="errors?.project"
              class="p-error">
              {{ errors.project | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="grid mt-3">
    <div class="lg:col-6 col-12 flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveTask()"></button>
      <button
        *ngIf="(form$ | async)?.isShowDelete && globalService.isAccessRule('HELPDESK:HELPDESK:DELETE_TASKS')"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteTask()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
